// @ts-check
import moment from 'moment-timezone'
import { absentModalController } from '../absent-modal/absent-modal.ctrl.js'
import absentTpl from '../absent-modal/absent-modal.html'
import dsbCtrl from '../../workforce/rate/dsb.ctrl'
import dsbTpl from '../../workforce/rate/dsb.html'
import {formatCertificationIcons, getCovidPolicyIcon} from '../../../component-templates/certification-icon/utils.js'

// Segment events
const rosterFavoriteEvent = 'roster_favorite'
const rosterMarkAbsent = 'roster_mark_absent'
const rosterDsb = 'roster_dsb'
const rosterViewProfile = 'roster_view_profile'

class ShiftProfileController {
  /* @ngInject */

  constructor(
    $scope,
    $window,
    $mdDialog,
    mdPanelRef,
    $mdToast,
    Jobs,
    Shifts,
    Users,
    jobs,
    selectedShift,
    selectedUser,
    segment,
    clock,
    undoHours,
    updateRosterProps,
    userChatFn,
    reactAppUrl,
    rosterUserCertificationService,
  ) {
    this.$scope = $scope
    this.$window = $window
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.mdPanelRef = mdPanelRef
    this.Jobs = Jobs
    this.Users = Users
    this.Shifts = Shifts
    this.selectedShift = selectedShift
    this.selectedUser = selectedUser
    this.segment = segment
    this.jobs = jobs
    this.selectedShiftJob = this.jobs.filter(job => job.id === this.selectedShift.job_id)
    this.undoHours = undoHours
    this.updateRosterProps = updateRosterProps
    this.userChatFn = userChatFn
    this.reactAppUrl = reactAppUrl
    this.clock = clock
    this.isClockedIn = this.selectedShift.timestamps && this.selectedShift.timestamps.length && this.selectedShift.category !== 'Clocked Out'
    this.isClockedOut = !this.selectedShift.timestamps || this.selectedShift.category === 'Clocked Out'
    this.isFavorite = this.selectedUser[0].is_favorite
    this.clockInOutEnabled = this.getClockInOutEnabled(this.selectedShift.start_time)
    this.covid_icon = getCovidPolicyIcon(this.selectedShift);
    this.rosterUserCertificationService = rosterUserCertificationService;
    this.fetchUserCertifications();

    // setting job object on the 'roster/shift' obj
    this.selectedShift.job = this.selectedShiftJob[0]
    this.closeDialog = () => this.mdPanelRef.close()
  }

  /**
   * This function fetches the user's certifications and sets them in the component's state to be displayed as icons.
   */
  async fetchUserCertifications() {
    const covidPolicyIcon = getCovidPolicyIcon(this.selectedShift);
    const userCertifications = await this.rosterUserCertificationService.getUserCertifications(this.selectedUser[0].external_id);

    // If they don't have any covid vaccination record (exemption or testing),
    // it'll still return an object but with empty fields and 'has_icon' as false
    this.userCertificationIcons = [
      ...(covidPolicyIcon.has_icon ? [covidPolicyIcon] : []),
      ...formatCertificationIcons(userCertifications),
    ];
  }

  getClockInOutEnabled (shiftStartTime) {
    // We should be able to Clock In/Out only shifts that are started yesterday or today
    const today = moment().tz(this.selectedShift.timezone);
    const yesterday = moment(today).tz(this.selectedShift.timezone).add(-1, 'days');
    const shiftStartDay = moment(shiftStartTime).tz(this.selectedShift.timezone);

    const isToday = shiftStartDay.isSame(today, "day");
    const isYesterday = shiftStartDay.isSame(yesterday, "day");
    return isToday || isYesterday;
  }

  handleFavorite (shift) {
    if (this.isFavorite) {
      this.unfavorite(shift)
    } else {
      this.favorite(shift)
    }
  }

  userChat (workerId) {
    this.closeDialog()
    this.userChatFn(workerId)
  }

  favorite (shift) {
    const user = this.selectedUser[0]

    // Segment event for tracking favorite action
    this.segment.track(rosterFavoriteEvent, {
      jobId: shift.job.id,
      scheduleId: shift.schedule_id,
      shiftId: shift.id
    })

    this.Users.favorite([user.external_id], shift.job.external_id)
      .then((res) => {
        this.updateRosterProps(user, { is_favorite: true })
        this.isFavorite = true
        const msg = `${user.fullname} added as a favorite!`
        this.$mdToast.showSimple(msg)
      })
      // .catch(this.$mdToast.showSimple('Error marking user as favorite'))
  }

  unfavorite (shift) {
    const user = this.selectedUser[0]

    this.Users.unfavorite([user.external_id], shift.job.external_id)
      .then((res) => {
        this.updateRosterProps(user, { is_favorite: false })
        this.isFavorite = false
        const msg = `${user.fullname} removed as favorite`
        this.$mdToast.showSimple(msg)
      })
      // .catch(this.$mdToast.showSimple('Error marking user as favorite'))
  }

  clockInOut () {
    const isClockedIn = this.selectedShift.category === 'Clocked-In'
    let type

    if (isClockedIn) {
      type = 'SHIFT_END'
    } else {
      type = 'SHIFT_START'
    }

    this.clock(type, this.selectedShift)

    // Segment Event Tracking
    this.segment.track('roster_clock_in_out', {
      job_id: this.selectedShift.job_id,
      scheduleId: this.selectedShift.schedule_id,
      shift: this.selectedShift.shift
    })

    this.closeDialog()
  }

  dontSendError (err) {
    this.$scope.$broadcast('app:loading:done')
    if (!err) return
    console.error(err)
    this.$mdToast.showSimple('Unable to mark user as don\'t send.')
  }

  dsb ($ev) {
    const roster = this.selectedShift
    this.closeDialog()

    if (roster.job) roster.job.timezone = roster.timezone
    const confirm = {
      controller: dsbCtrl,
      controllerAs: 'dsb',
      template: dsbTpl,
      fullscreen: true,
      targetEvent: $ev,
      clickOutsideToClose: true,
      locals: {
        worker: roster.worker,
        job: roster.job,
        schedule: roster.schedule_name || null, // gets filled in below if roster.schedule_id exists
        ratingType: null
      }
    }
    let fetchScheduleDetails = Promise.resolve()
    let dsbResults
    return fetchScheduleDetails.then(() => this.$mdDialog.show(confirm))
      .then((results) => {
        dsbResults = results
        if (!dsbResults.endDate) return this.Users.dontSend(roster.external_id, dsbResults.reason, dsbResults.dsbRating, dsbResults.categoryId, roster.job.external_id)
        this.Jobs.repost({
          address_id: roster.address_id,
          days: results.days,
          daysOfWeek: roster.days,
          department: roster.department_id,
          dsb: 1,
          endDate: results.endDate,
          jobId: roster.job.external_id,
          needed: results.needed,
          position_id: roster.position_id,
          startDate: results.startDate,
          supervisor: roster.supervisor_id,
          timezone: results.timezone,
          wage: roster.wage
        }).then(this.Users.dontSend(roster.external_id, dsbResults.reason, dsbResults.dsbRating, dsbResults.categoryId, roster.job.external_id))
      })
      .then(this.Users.removeWorker(roster.external_id))
      .then(this.Users.getWorkforce())
      .then(() => {
        roster.dont_send_back = true
        this.$mdToast.showSimple(`Marked ${roster.fullname} as don\'t send.`)
        this.segment.track(rosterDsb, {
          job_id: roster.job_id,
          scheduleId: roster.schedule_id,
          shift: roster.shift
        })
      })
      .catch(this.dontSendError.bind(this))
  }

  markAbsent ($ev) {
    this.closeDialog()
    const roster = this.selectedShift
    const confirm = {
      controller: absentModalController,
      controllerAs: 'm',
      template: absentTpl,
      fullscreen: true,
      targetEvent: $ev,
      clickOutsideToClose: true,
      locals: {
        roster: roster,
        job: roster.job,
      }
    }

    return this.$mdDialog.show(confirm)
    .then((res) => {
      this.$mdToast.showSimple(`Marked ${roster.fullname} absent`)
      this.updateRosterProps(res.roster, { category: res.category, usersHoursReasonCode: res.usersHoursReasonCode })
      // Segment Event Tracking
      this.segment.track(rosterMarkAbsent, {
        jobId: roster.job_id,
        scheudleId: roster.schedule_id,
        shift: roster.shift
      })
      if (res.dsb) {
        this.dsb($ev)
      }
    })
  }

  undoMarkAbsent () {
    this.closeDialog()
    this.undoHours(this.selectedShift.hours_id, this.selectedShift)
  }

  /*
   TODO: Re-use functions already defined in roster.ctrl.js
   Redirect to GetCrewForm (web-react) with pre-populated URL params
   for direct hire user position ID is inferred as the user's latest scheduled job.
   */
  directHireFromShiftProfileCard (user) {
    const directInviteUserIdParam = `directInviteUserIds=${JSON.stringify(user.external_id)}`;
    const directInvitePositionParam = `position=${user.position_id}`;
    let directInviteUrl = `${this.reactAppUrl}/jobs/post?${directInviteUserIdParam}&${directInvitePositionParam}`;
    this.$window.location.href = directInviteUrl;
  }

  viewProfileRedirect (userId) {
    this.closeDialog()

    // Segment Event Tracking
    this.segment.track(rosterViewProfile, {
      userId
    })

    this.$window.location.href = `/app.html#!/resume/${userId}`
  }
}

export default ShiftProfileController
